

























import { defineComponent, PropType, ref } from '@nuxtjs/composition-api';
import useMyLocation from '@shared/composables/useMyLocation';
import { getBrowserLocation } from '@shared/helpers/getBrowserLocation';
import { NearbyStoreParams } from '@shared/types/locations';
import { StoreDetails } from '@shared/types/stores';
import { UCIcon } from '@shared/ui';

import SuburbLookup from '~/components/Stores/SuburbLookup.vue';

export default defineComponent({
  name: 'NearestStoreSearch',
  components: { SuburbLookup, UCIcon },
  props: {
    onChange: {
      type: Function as PropType<(value: NearbyStoreParams) => void>,
      required: true,
    },
    onShowAllStores: {
      type: Function as PropType<(value: NearbyStoreParams) => void>,
      required: true,
    },
  },
  setup(props) {
    const loadingCurrentLocation = ref(false);
    const stores = ref<StoreDetails[]>([]);
    const suburbs = ref(null);
    const { myLocation } = useMyLocation();

    const getCurrentLocation = async () => {
      loadingCurrentLocation.value = true;
      try {
        const { lat, lng } = myLocation.value ?? (await getBrowserLocation());
        await props.onChange({ lat, lng });
      } catch (err) {
        console.error(err);
      } finally {
        loadingCurrentLocation.value = false;
      }
    };

    const onPostcodeSubmit = (placeId: string) => props.onChange({ placeId });

    const onPostcodeClear = () => props.onChange({ placeId: '' });

    return {
      suburbs,
      loadingCurrentLocation,
      stores,
      getCurrentLocation,
      onPostcodeSubmit,
      onPostcodeClear,
    };
  },
});
